import React, { useState } from 'react';
import { editStockSplitData } from './services/stockSplitCalenderService';

const EditStockSplitForm = ({ onClose, item, corporateActions }) => {
  const [formData, setFormData] = useState({
    id: item.id,
    stockname: item.stockname,
    sourcedon: item.sourcedon,
    status: item.status,
    corporateaction: item.corporateaction
  });

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await editStockSplitData(formData);
      setShowSuccessModal(true); // Show success modal
    } catch (error) {
      console.error('Error updating stock split:', error);
      setErrorMessage(error.message || 'Failed to update stock split.');
      setShowErrorModal(true); // Show error modal
    }
  };

  const handleCloseSuccessModal = () => {
    setShowSuccessModal(false);
    onClose(); // Close everything
  };

  const handleCloseErrorModal = () => {
    setShowErrorModal(false); // Just close the error modal, don't close the edit form
  };

  return (
    <>
      {/* Edit Modal (Hidden when Success Modal is shown) */}
      {!showSuccessModal && !showErrorModal && (
        <div className="modal" style={{ display: 'block' }}>
          <div className="modal-dialog " style={{ marginTop: '80px' }}>
              <div className="modal-content" style={{ width: '600px', height: '420px', backgroundColor: '#e6e8ec' }}>
                <div className="modal-header">
                <h5 className="modal-title">Edit Stock Split</h5>
                <button type="button" className="btn-close" onClick={onClose}></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSubmit} className="row g-3">
                  <div className="row align-items-center mb-3 fw-bold">
                    <label className="col-sm-3 col-form-label">Stock Name</label>
                    <div className="col-sm-9">
                      <input type="text" className="form-control" name="stockname" value={formData.stockname} onChange={handleInputChange} required  />
                    </div>
                  </div>
                  <div className="row align-items-center mb-3 fw-bold">
                    <label className="col-sm-3 col-form-label">Source Date</label>
                    <div className="col-sm-9">
                      <input type="date" className="form-control" name="sourcedon" value={formData.sourcedon} onChange={handleInputChange} required />
                    </div>
                  </div>
                  <div className="row align-items-center mb-3 fw-bold">
                    <label className="col-sm-3 col-form-label">Status</label>
                    <div className="col-sm-9">
                      <select className="form-select" name="status" value={formData.status} onChange={handleInputChange} required>
                        <option value="">Select Status</option>
                        <option value="1">Completed</option>
                        <option value="0">Pending</option>
                      </select>
                    </div>
                  </div>
                  <div className="row align-items-center mb-3 fw-bold">
                    <label className="col-sm-3 col-form-label">Corporate Action</label>
                    <div className="col-sm-9">
                      <select className="form-select" name="corporateaction" value={formData.corporateaction} onChange={handleInputChange} required>
                        <option value="">Select Corporate Action</option>
                        {corporateActions.map((action, index) => (
                          <option key={index} value={action}>{action}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="text-end">
                    <button type="submit" className="btn btn-primary">Update</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Success Modal (Only Shown When Update is Successful) */}
      {showSuccessModal && (
        <div className="modal" style={{ display: 'block' }}>
          <div className="modal-dialog" style={{ margin: 'auto', marginTop: '100px' }}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title text-success">Success</h5>
              </div>
              <div className="modal-body">
                <p>Stock split updated successfully!</p>
              </div>
              <div className="modal-footer">
                <button className="btn btn-success" onClick={handleCloseSuccessModal}>OK</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Error Modal (Only Shown When Update Fails) */}
      {showErrorModal && (
        <div className="modal" style={{ display: 'block' }}>
          <div className="modal-dialog" style={{ margin: 'auto', marginTop: '100px' }}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title text-danger">Error</h5>
              </div>
              <div className="modal-body">
                <p>{errorMessage}</p>
              </div>
              <div className="modal-footer">
                <button className="btn btn-danger" onClick={handleCloseErrorModal}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default EditStockSplitForm;
